// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { ProductCardFragmentDoc } from '../../layout/cards/ProductCard.generated';
import { ProductLinkFragmentDoc } from '../../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../useImageProps.generated';
import { ProductListAnalyticsFragmentDoc } from '../../../views/product/composables/analytics/useProductAnalytics.generated';
export const ProductGridFragmentDoc = `
    fragment productGrid on CatalogueProduct {
  ...productCard
  ...productListAnalytics
  ... on CatalogueEngagementRing {
    variationsByPrimaryMetal {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueWeddingRing {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryRing {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryBracelet {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryNecklace {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryEarrings {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
}
    `;